import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { setSelectedAdvertiser, setSelectRentalCar } from "../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  cursor: pointer;
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: ${({ theme }) => theme.secondaryBgColor};
      .row {
        width: 100%;
        display: grid;
        grid-template-columns:  repeat(8, 1fr);
        align-items: center;
        justify-content: center;
        min-height: 40px;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          text-align: center;
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }
`;

const SurucuArayanlarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
 
  return (
    <Container onClick={() => {dispatch(setSelectedAdvertiser(data)); dispatch(showModal("driverSeekerOptions"))}} >
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data?.id}</div>
            <div className="col">{moment(data?.createdAt).format("DD.MM.YYYY")}</div>
            <div className="col">{data?.contactNumber}</div>
            <div className="col">{data?.driverSeekerWorkCities?.$values?.map((item) => {return( <span>{item.city},{" "}</span> )})}</div>
            <div className="col">{data?.driverCount}</div>
            <div className="col">{data?.salary}</div>
            <div className="col">{data?.otherBenefits}</div>
            <div className="col">{data?.weekHoliday}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SurucuArayanlarContainer;
